import { useEffect, useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { toast } from "../../toast";
import { Button, Label, TextInput, Spinner } from "flowbite-react";
import NavBar from "../../Common/NavBar";
import { useNavigate, useSearchParams } from "react-router-dom";

const REQUEST_STUDENT_PASSWORD_RESET = gql`
  mutation RequestStudentPasswordReset($email: String!) {
    requestStudentPasswordReset(email: $email)
  }
`;

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [requestStudentPasswordReset] = useMutation(
    REQUEST_STUDENT_PASSWORD_RESET,
  );

  useEffect(() => {
    const rawEmail = searchParams.get("email") || searchParams.get("login_hint") || "";
    if (!rawEmail) return;

    const decodedEmail = decodeURIComponent(rawEmail).trim();
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(decodedEmail);

    // Only prefill when it is a valid email; ignore tokens like oobCode.
    if (isValidEmail) {
      setEmail(decodedEmail);
    }
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Set loading to true when form is submitted

    const genericMessage =
      "If your account exists, a password reset link has been sent to your email.";

    try {
      await requestStudentPasswordReset({ variables: { email } });
      toast.success(genericMessage);
      navigate("/login");
    } catch (error) {
      // Always show a generic message to avoid account enumeration.
      toast.success(genericMessage);
      navigate("/login");
    } finally {
      setIsLoading(false); // Set loading back to false after submission
    }
  };

  return (
    <>
      <NavBar />
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg"
        >
          <img
            className="w-auto h-24 mx-auto mb-8"
            src="/favicon.ico"
            alt="Your Company"
          />
          <h2 className="mt-8 mb-6 text-2xl font-extrabold text-center text-gray-800">
            Forgot Password
          </h2>
          <Label>User Email:</Label>
          <TextInput
            type="email"
            name="email"
            placeholder="Enter your email address"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            required
            className="mb-6"
          />
          <Button
            type="submit"
            className="flex items-center justify-center w-full bg-primary"
            disabled={isLoading} // Disable button while loading
          >
            {isLoading && <Spinner size="sm" className="mr-2" />}
            Submit
          </Button>
        </form>
      </div>
    </>
  );
}

export default ForgotPassword;
